import i from "clsx";
import e from "react";
import { s as o } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function c({
  size: t = "small",
  accessibilityTitle: l = "glyph download solid",
  className: r,
  "data-testid": a,
  fill: s,
  stroke: n
}) {
  const d = () => i(r, o["ride-glyph"], {
    [o[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: d(), "data-testid": a }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: s || "#03050F",
      stroke: n || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    l && /* @__PURE__ */ e.createElement("title", null, l),
    /* @__PURE__ */ e.createElement("path", { d: "M6.00002 25H26V28H6.00002V25ZM26.92 11.62C26.845 11.4374 26.7176 11.281 26.5539 11.1707C26.3902 11.0604 26.1974 11.001 26 11H22V4H10V11H6.00002C5.80259 11.001 5.60987 11.0604 5.44615 11.1707C5.28243 11.281 5.15504 11.4374 5.08002 11.62C5.00344 11.8021 4.98252 12.0028 5.01989 12.1968C5.05726 12.3908 5.15126 12.5694 5.29002 12.71L15.29 22.71C15.3835 22.8027 15.4943 22.876 15.6161 22.9258C15.7379 22.9755 15.8684 23.0008 16 23C16.1316 23.0008 16.2621 22.9755 16.3839 22.9258C16.5058 22.876 16.6166 22.8027 16.71 22.71L26.71 12.71C26.8488 12.5694 26.9428 12.3908 26.9801 12.1968C27.0175 12.0028 26.9966 11.8021 26.92 11.62V11.62Z" })
  ));
}
export {
  c as RideGlDownloadSolid
};
